export const docCopy = {
  nav_: {
    id: "foo",
    defaultMessage: "foo",
  },
}
